import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonTinyHeavy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.9268 12.41C14.3583 12.41 16.3294 10.4379 16.3294 8.00504C16.3294 5.57222 14.3583 3.60004 11.9268 3.60004C9.4953 3.60004 7.52417 5.57222 7.52417 8.00504C7.52417 10.4379 9.4953 12.41 11.9268 12.41Z",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.70007 20.2389C9.12783 16.8093 14.694 16.8093 18.1375 20.2389",
		stroke: "currentColor",
		strokeWidth: 3,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgPersonTinyHeavy);
export default ForwardRef;
